import { useEffect, useContext } from "react";
import { SocketContext } from "../context/Socket/SocketContext";
import { AuthContext } from "../context/Auth/AuthContext";

export const useKanbanSocket = (boardId, onUpdate) => {
  const socketManager = useContext(SocketContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!boardId || !socketManager) return;

    const socket = socketManager.getSocket(user.companyId);

    if (!socket) return;

    const companyChannel = `company-${user.companyId}-mainchannel`;
    const boardChannel = `company-${user.companyId}-kanban-${boardId}`;

    // Entrar nos canais
    socket.emit("joinChatBox", companyChannel);
    socket.emit("joinChatBox", boardChannel);

    // Listeners para eventos de Board
    const handleBoardEvent = (data) => {
      console.log("Board event:", data);
      if (onUpdate) {
        onUpdate({ type: "board", ...data });
      }
    };

    // Listeners para eventos de Column
    const handleColumnEvent = (data) => {
      console.log("Column event:", data);
      if (onUpdate) {
        onUpdate({ type: "column", ...data });
      }
    };

    const handleColumnsReordered = (data) => {
      console.log("Columns reordered:", data);
      if (onUpdate) {
        onUpdate({ type: "columnsReordered", ...data });
      }
    };

    const handleBoardsReordered = (data) => {
      console.log("Boards reordered:", data);
      if (onUpdate) {
        onUpdate({ type: "boardsReordered", ...data });
      }
    };

    // Listeners para eventos de Card
    const handleCardEvent = (data) => {
      console.log("Card event:", data);
      if (onUpdate) {
        onUpdate({ type: "card", ...data });
      }
    };

    const handleCardMoved = (data) => {
      console.log("Card moved:", data);
      if (onUpdate) {
        onUpdate({ type: "cardMoved", ...data });
      }
    };

    const handleCardsReordered = (data) => {
      console.log("Cards reordered:", data);
      if (onUpdate) {
        onUpdate({ type: "cardsReordered", ...data });
      }
    };

    // Registrar listeners
    socket.on("kanban:board", handleBoardEvent);
    socket.on("kanban:column", handleColumnEvent);
    socket.on("kanban:columnsReordered", handleColumnsReordered);
    socket.on("kanban:boardsReordered", handleBoardsReordered);
    socket.on("kanban:card", handleCardEvent);
    socket.on("kanban:cardMoved", handleCardMoved);
    socket.on("kanban:cardsReordered", handleCardsReordered);

    // Cleanup
    return () => {
      socket.off("kanban:board", handleBoardEvent);
      socket.off("kanban:column", handleColumnEvent);
      socket.off("kanban:columnsReordered", handleColumnsReordered);
      socket.off("kanban:boardsReordered", handleBoardsReordered);
      socket.off("kanban:card", handleCardEvent);
      socket.off("kanban:cardMoved", handleCardMoved);
      socket.off("kanban:cardsReordered", handleCardsReordered);
    };
  }, [boardId, socketManager, user.companyId, onUpdate]);
};

export default useKanbanSocket;
